module.exports = __webpack_public_path__ + "img/couponclass7rc0.9cf2ea55.png";